import { useId } from "react";

import { Icon } from "@/design-system";

export default function MobileFilterPanel({ open, onToggle, children }) {
  const panelId = useId();

  return (
    <div className="mb-[var(--space-4)] lg:hidden">
      <button
        type="button"
        onClick={onToggle}
        aria-expanded={open}
        aria-controls={panelId}
        className="flex h-[var(--control-height-md)] w-full items-center justify-between rounded-control border border-line bg-card px-[var(--space-4)] font-sans text-sm font-semibold text-ink shadow-sm [transition:background_var(--duration-fast),border-color_var(--duration-fast)] hover:border-line-strong hover:bg-neutral-50 focus-visible:outline-none focus-visible:[box-shadow:var(--focus-ring)]"
      >
        <span className="inline-flex items-center gap-[var(--space-2)]">
          <Icon
            name="tune"
            size={18}
            weight={400}
            className="text-orange-500"
          />
          Filters
        </span>
        <Icon
          name="expand_more"
          size={20}
          weight={400}
          className={`text-ink-3 [transition:transform_var(--duration-base)_var(--ease-spring)] ${open ? "rotate-180" : ""}`}
        />
      </button>

      {open && (
        <div id={panelId} className="mt-[var(--space-2)]">
          {children}
        </div>
      )}
    </div>
  );
}
